// import { useEffect, useMemo } from "react";
// import {
//   useTable,
//   useGlobalFilter,
//   useSortBy,
//   usePagination,
// } from "react-table";

// const useGlobalTable = (columns, data, isModal = false) => {
//   const currentPageName =
//     window.location.hash.split("/crm/")[1]?.split("/")[0] || "defaultPage";
//   const urlParts = window.location.hash.split("/crm/")[1]?.split("/") || [];
//   const hasSubPath = urlParts.length > 1;
//   const savedState = JSON.parse(localStorage.getItem("paginationState")) || {};
//   const savedSearchTerm = localStorage.getItem("searchTerm") || "";

//   const initialPageIndex =
//     savedState?.pageName === currentPageName &&
//     savedState?.pageIndex !== undefined &&
//     !isModal
//       ? savedState.pageIndex
//       : 0;

//   const initialPageSize =
//     savedState?.pageName === currentPageName &&
//     savedState?.pageSize !== undefined &&
//     !isModal
//       ? savedState.pageSize
//       : 10;
//   const initialState = useMemo(
//     () => ({
//       pageIndex: initialPageIndex,
//       pageSize: initialPageSize,
//       globalFilter: savedSearchTerm,
//     }),
//     [initialPageIndex, initialPageSize, savedSearchTerm]
//   );

//   // Initialize the table instance with react-table hooks
//   const tableInstance = useTable(
//     {
//       columns,
//       data,
//       initialState, // Pass initialState properly initialized
//     },
//     useGlobalFilter,
//     useSortBy,
//     usePagination
//   );

//   const {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     page,
//     canPreviousPage,
//     canNextPage,
//     pageOptions,
//     pageCount,
//     gotoPage,
//     nextPage,
//     previousPage,
//     setPageSize,
//     setGlobalFilter,
//     state: { pageIndex, pageSize, globalFilter },
//   } = tableInstance || {};

//   // Ensure the table goes to page 0 when the URL has sub-paths
//   useEffect(() => {
//     if (hasSubPath) {
//       gotoPage(0);
//     }
//   }, [hasSubPath]);

//   // Save pagination and filter states to localStorage (except for modal tables)

//   return {
//     getTableProps,
//     getTableBodyProps,
//     headerGroups,
//     prepareRow,
//     page,
//     canPreviousPage,
//     canNextPage,
//     pageOptions,
//     pageCount,
//     gotoPage,
//     nextPage,
//     previousPage,
//     setPageSize,
//     setGlobalFilter,
//     pageIndex,
//     pageSize,
//     globalFilter,
//   };
// };

// export default useGlobalTable;



import { useMemo } from "react";
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";

const useGlobalTable = (columns, data, isModal = false, options = {}) => {
  // const currentPageName =
  //   window.location.hash.split("/crm/")[1]?.split("/")[0] || "defaultPage";
  // const urlParts = window.location.hash.split("/crm/")[1]?.split("/") || [];
  // const hasSubPath = urlParts.length > 1;
  
  // Don't use localStorage for now - persistence commented out
  // const savedState = isModal ? {} : (JSON.parse(localStorage.getItem("paginationState")) || {});
  // const savedSearchTerm = isModal ? "" : (localStorage.getItem("searchTerm") || "");

  // const initialPageIndex =
  //   !isModal &&
  //   savedState?.pageName === currentPageName &&
  //   savedState?.pageIndex !== undefined
  //     ? savedState.pageIndex
  //     : 0;

  // const initialPageSize =
  //   !isModal &&
  //   savedState?.pageName === currentPageName &&
  //   savedState?.pageSize !== undefined
  //     ? savedState.pageSize
  //     : 10;

  // Always start fresh without persistence
  const initialState = useMemo(
    () => ({
      pageIndex: 0,
      pageSize: 10,
      globalFilter: "",
    }),
    []
  );

  // Initialize the table instance with react-table hooks
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState,
      ...options,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    state: { pageIndex, pageSize, globalFilter },
  } = tableInstance || {};

  // Persistence logic commented out
  // useEffect(() => {
  //   if (hasSubPath && !isModal) {
  //     gotoPage(0);
  //   }
  // }, [hasSubPath, isModal, gotoPage]);

  return {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    pageIndex,
    pageSize,
    globalFilter,
  };
};

export default useGlobalTable;